export const MAX_WORK_ORDER_ITEMS = 250
